define(
    'providers/dataprovider',[
        "durandal/app",
        "services/config",
        "services/log",
        "services/eventbroker",
        "i19n!i19n/strings",
        "providers/dataprovider.accesscontrol",
        "providers/dataprovider.accesscontrol.library",
        "providers/dataprovider.accesscontrol.listvalue",
        "providers/dataprovider.accesscontrol.folder",
        "providers/dataprovider.accounts",
        "providers/dataprovider.documents",
        "providers/dataprovider.folders",        
        "providers/dataprovider.libraries",
        "providers/dataprovider.lists",
        "providers/dataprovider.persons",
        "providers/dataprovider.organisations",
        "providers/dataprovider.teams",
        "providers/dataprovider.lookups",
        "providers/dataprovider.settings",
        "providers/dataprovider.search",
        "providers/dataprovider.subscription",
        "providers/dataprovider.templatefolders",
        "providers/dataprovider.templatelibraries",
        "providers/dataprovider.templatedocuments",
        "providers/dataprovider.signurl"
    ],
    function (app, config, log, eventBroker, i19n,
        accessControl,
        accesscontrollibrary,
        accesscontrollistvalue,
        accesscontrolfolder,
        accounts,
        documents,
        folders,
        libraries,       
        lists,
        persons,
        organisations,
        teams,
        lookups,
        settings,
        search,
        subscription,
        templatefolders,
        templatelibraries,
        templatedocuments,
        signurl
        )
    {

        var dataProvider = {
            accessControl: accessControl,
            accesscontrollibrary: accesscontrollibrary,
            accesscontrollistvalue: accesscontrollistvalue,
            accesscontrolfolder: accesscontrolfolder,
            accounts: accounts,
            documents: documents,
            folders: folders,
            libraries: libraries,            
            lists: lists,
            persons: persons,
            organisations: organisations,
            teams: teams,
            lookups : lookups,
            settings: settings,
            search: search,
            subscription: subscription,
            templatefolders: templatefolders,
            templatelibraries: templatelibraries,
            templatedocuments: templatedocuments,
            signurl: signurl
        };

        amplify.subscribe("request.before.ajax", function(resource, settings, ajaxSettings, xhr) {
            xhr.setRequestHeader("InstanceCode", config.instanceCode);
            xhr.setRequestHeader("accept-language", window.fileplan.settings.locale);
            
            app.isBusy(true);
            log.data("resource: %o requested with: %o", resource, settings.data || settings);
        });

        amplify.request.decoders._default = decoder(true);
        amplify.request.decoders.quiet = decoder(false);
        
        return dataProvider;

//        function localizeErrorMessages(errors) {
//            _.map(errors, function (error) {
//                var localizedErrorMessage = i19n.errors[error.code] || error.phrase;
//                error.tokens.splice(0, 0, localizedErrorMessage);
//                error.phrase = String.format.apply(null, error.tokens);
//            });
//        }

        function decoder(publishErrorEvents) {
            return function(data, status, xhr, success, error) {
                app.isBusy(false);
                if (xhr.status >= 200 && xhr.status < 300) {
                    log.data("resource callback: ", xhr.responseText);
                    success(data, xhr.status);
                } else {

                    if (xhr.status == 500)
                        unexpectedExceptionHandler(xhr, publishErrorEvents);
                    else
                        expectedErrorHandler(xhr, publishErrorEvents, error);
                }
            };
        }

        function unexpectedExceptionHandler(xhr, publishErrorEvents) {
            if (publishErrorEvents) {

                try {
                    var exceptionDetails = JSON.parse(xhr.responseText); // the standard webapi 500 json details
                    eventBroker.trigger(this, config.events.errors.serverException, exceptionDetails, xhr.status, xhr);
                }
                catch (e)
                {
                    // an asp.net fwk exception (url not found etc)
                    eventBroker.trigger(this, config.events.errors.serverException, xhr.responseText, xhr.status, xhr);
                }
            }
        }

        function expectedErrorHandler(xhr, publishErrorEvents, errorHandler) {
            try {
                if (xhr.responseText) {
                    var errorJson = JSON.parse(xhr.responseText);

                    //TODO: 11-Oct-2013 - Ben - the server is localizing error messages. No need for this client to do it as well.
                    //localizeErrorMessages(errorJson);
                    
                    var result = {
                        stopPropagation: false,
                        error : errorJson
                    };

                    errorHandler(result, xhr.status);

                    if (!result.stopPropagation && publishErrorEvents) {
                        eventBroker.trigger(this, config.events.errors.ajax, errorJson, xhr.status, xhr);
                    }
                    
                } else {
                    eventBroker.trigger(this, config.events.errors.serverException, "An unexpected error occurred", xhr.status, xhr);
                }

            } catch (e) {
                if (publishErrorEvents) {
                    eventBroker.trigger(this, config.events.errors.serverException, e.message, xhr.status, xhr);
                }
            }

        }
    }
);
